import React from 'react';
import classnames from 'classnames';
import _ from 'lodash';
import Loader from 'app/components/general/Loader';

interface ITitleProps {
  title: string;
  unit: string;
  infoText: string;
  breadcrumb: boolean;
  isLoading: boolean;
  badge: React.ReactNode;
}

export default class Title extends React.Component<ITitleProps> {
  static defaultProps = {
    title: '',
    unit: '',
    infoText: '',
    breadcrumb: false,
    isLoading: false,
    badge: undefined,
  };

  render(): React.ReactNode {
    return (
      <div
        className={classnames('title-container', {
          'with-breadcrumb': this.props.breadcrumb,
        })}
      >
        <div className="row">
          <div className="col">
            {this.props.isLoading && (<Loader skeleton height={25} isActive color="grey" />)}
            {!this.props.isLoading && (
              <div className="title-container-text">
                <h1 className={classnames('d-inline-block', { 'with-unit': !_.isEmpty(this.props.unit) })}>{this.props.title}</h1>
                {!_.isEmpty(this.props.unit) && (<h1 className="d-inline-block text-light-grey">{this.props.unit}</h1>)}
                <div className="badge-container">
                  {this.props.badge !== undefined && this.props.badge}
                </div>
              </div>
            )}
          </div>
          {!_.isEmpty(this.props.infoText) && (
            <div className="col text-right">
              <div className="info-text">
                <span className="caption-text">{this.props.infoText}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
